import Client from "./client";

// The signed-in account's own billing state - what it's on, what it costs,
// when it ends, and what it has paid. See api/routes/subscriptions.js.

export const GetMySubscription = (accessToken) => {
    return new Promise((resolve, reject) => {
        Client.get('/api/subscriptions/me', {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong loading your subscription." });
        })
    })
}

export const CancelSubscription = ({reason, comment, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post('/api/subscriptions/cancel', {reason, comment}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong cancelling your subscription." });
        })
    })
}

// Called by the thank-you page with the checkout session id Stripe puts on its
// return URL. The API checks with Stripe that the session really belongs to this
// account before recording it.
export const ConfirmStripeCheckout = ({sessionId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post('/api/subscriptions/stripe/confirm', {sessionId}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong confirming your payment." });
        })
    })
}

// Starts a Stripe checkout and hands back the hosted page the member has to
// complete. A trial converting is charged the plan it's pinned to, so it needs
// no arguments; a Starter or lapsed account names what it's buying.
export const StartCheckout = ({planTier, billingInterval, planCode, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post('/api/subscriptions/checkout', {planTier, billingInterval, planCode}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong starting checkout." });
        })
    })
}

// Starts the account's one-time free trial on a paid plan - no Stripe
// involved, and nothing to redirect to; the response carries the new
// TRIALING subscription directly. Only works once per account ever (see
// GetMySubscription's canStartTrial) - past that, StartCheckout is the way
// onto a paid plan.
export const StartTrial = ({planTier, billingInterval, planCode, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post('/api/subscriptions/start-trial', {planTier, billingInterval, planCode}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong starting your trial." });
        })
    })
}

// Moves a subscription that already exists at Stripe onto a different plan.
// Applied immediately - there is nothing for the member to approve, so this
// comes back with the new state rather than somewhere to send them.
export const ChangePlan = ({planTier, billingInterval, planCode, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post('/api/subscriptions/change-plan', {planTier, billingInterval, planCode}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong changing your plan." });
        })
    })
}

// A link to Stripe's hosted portal, for changing the card on file and reading
// invoices. Only meaningful once an account has checked out.
export const OpenBillingPortal = (accessToken) => {
    return new Promise((resolve, reject) => {
        Client.post('/api/subscriptions/billing-portal', {}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong opening the billing portal." });
        })
    })
}
